<template>
  <div class="maindiv sindex-wrap sindex_main">
    <div class="ht200 sindex-bg"></div>
    <div class="wd1200 pt20 fs0">
      <div class="mediadiv dinline-block vtop br2">
        <div class="st pb10">
          <router-link to="/evn/list?id=2&pid=2" class="more fr tc6 br30 mt5 trans3 fs14 mt10">更多 +</router-link>
          <div class="fs24 mr5 dinline-block prelative">
            <span class="img-media img-bg dinline-block vbottom mr10"></span>
            媒体聚焦
          </div>
        </div>
        <div class="cont border-red ht350 pt30 pl15">
          <div class="dinline-block mcter vtop">
            <img src="../../assets/images/other_08.jpg" />
          </div>
          <div class="dinline-block mot vtop pl20">
            <template v-if="info.media_focus" v-for="(item,index) in info.media_focus">
              <router-link :to="`/evn/detail?pid=2&id=2&num=${index+1}&article_id=${item.id}`" class="dblock fs16 lh18 mb10 ofhidden hred">
                {{item.title}}</router-link>
            </template>
          </div>
        </div>
      </div>
      <div class="sinfodiv wd380 dinline-block vtop br2">
        <div class="st pb10">
          <router-link :to="{path:'/evn/content',query:{id:0,pid:1}}" class="more fr tc6 br30 mt5 trans3 fs14 mt10">更多 +</router-link>
          <div class="fs24 mr5 dinline-block prelative">
            <span class="img-sinfo img-bg dinline-block vbottom mr5"></span>
            学院概况
          </div>
        </div>
        <div class="cont border-red ht350 pt25">
          <div @click="$router.push({path:child.to,query:{id:index,pid:1}})" v-for="(child,index) in $params['column'][1]['children']" class="sdiv dinline-block vtop fs16 tc6 cpointer prelative bg-f4 br5 hred mb20">
            <div class="pabsolute br50"></div>
            <span class="nm">{{child.name}}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="newsdiv wd1200 pt25 fs0 pb30">
      <div class="notices wd380 dinline-block vtop br2">
        <div class="st pb10">
          <router-link to="/enroll/article/list?pid=3&category_id=7" class="more fr tc6 br30 mt5 trans3 fs14 mt10">更多 +</router-link>
          <div class="dinline-block">
            <div class="fs24 mr5 dinline-block prelative">
              <span class="img-schange img-bg dinline-block vbottom"></span>
              招生动态
            </div>
          </div>
        </div>
        <div class="border-red ht350 pt15 pl15 pr10">
          <template v-if="newsinfo.enrollment_news">
            <div v-for="(item,index) in newsinfo.enrollment_news" :key="item.id"
              class="sdiv pl5 cpointer fs16 lh18 ofhidden prelative mb5 pl20 pr5"
                 @click="$router.push(`/enroll/article/detail?pid=3&category_id=${$params['enrollColumn'][3]['params']['category_id']}&article_id=${item.id}`)">
              {{item.title}}
            </div>
          </template>
        </div>
      </div>
      <div class="notices wd380 dinline-block vtop br2">
        <div class="st pb10">
          <router-link to="/enroll/article/list?pid=2&id=0&category_id=3" class="more fr tc6 br30 mt5 trans3 fs14 mt10">更多 +</router-link>
          <div class="dinline-block">
            <div class="fs24 mr5 dinline-block prelative">
              <span class="img-splan img-bg dinline-block vbottom"></span>
              招生计划
            </div>
          </div>
        </div>
        <div class="border-red ht350 pt15 pl15 pr10">
          <template v-if="planinfo.enrollment_plan">
            <div v-for="(item,index) in planinfo.enrollment_plan" :key="item.id"
                 class="sdiv pl5 cpointer fs16 lh18 ofhidden prelative mb5 pl20 pr5"
                 @click="$router.push(`/enroll/article/detail?pid=2&id=0&category_id=${$params['enrollColumn'][2]['children'][0]['params']['category_id']}&article_id=${item.id}`)">
              {{item.title}}
            </div>
          </template>
        </div>
      </div>
      <div class="notices wd380 dinline-block vtop br2">
        <div class="st pb10">
          <router-link to="/enroll/article/list?pid=5&category_id=9" class="more fr tc6 br30 mt5 trans3 fs14 mt10">更多 +</router-link>
          <div class="dinline-block">
            <div class="fs24 mr5 dinline-block prelative">
              <span class="img-sproblem img-bg dinline-block vbottom"></span>
              常见问题
            </div>
          </div>
        </div>
        <div class="border-red ht350 pt15 pl15 pr10">
          <template v-if="info.common_problem">
            <div v-for="(item,index) in info.common_problem" :key="item.id"
                 class="sdiv pl5 cpointer fs16 lh18 ofhidden prelative mb5 pl20 pr5"
                 @click="$router.push(`/enroll/article/detail?pid=5&category_id=${$params['enrollColumn'][5]['params']['category_id']}&article_id=${item.id}`)">
              {{item.title}}
            </div>
          </template>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "index",
  data(){
    return {
      info:{},
      planinfo:{},
      newsinfo:{},
    }
  },
  created() {
    this.getData();
  },
  mounted() {
    this.getnewsData();
    this.getplanData();
  },
  methods:{
    getData(){
      this.$request.get('recruit-home',[],response => {
        if(response.data.code == 200){
          this.info = response.data.data
        }
        console.log(this.info)
      },error => {
        console.log(error)
      })
    },
    getplanData(){
      this.$request.get('enrollment-plan',[],response => {
        if(response.data.code == 200){
          this.planinfo = response.data.data
        }
        console.log(this.infos)
      },error => {
        console.log(error)
      })
    },
    getnewsData(){
      this.$request.get('enrollment-news',[],response => {
        if(response.data.code == 200){
          this.newsinfo = response.data.data
        }
        console.log(this.infos)
      },error => {
        console.log(error)
      })
    },
  }
}
</script>

<style scoped>
  .sindex-bg{background: url(../../assets/images/sindex_01.jpg) no-repeat center top}
  .mediadiv {margin-right: 30px;width: 790px;}
  .mediadiv .mcter{width: 385px;height: 235px;}
  .mediadiv .mot{width: 380px;}
  .mediadiv .mot a{height: 28px;}
  .sinfodiv .sdiv{padding-left: 48px;width: 150px;height: 60px;}
  .sinfodiv .sdiv:hover{background-color: #94070a;color: #fff;box-shadow: 0 0 5px #94070a;}
  .sinfodiv .sdiv:hover .br50{background: #fff;}
  .sinfodiv .sdiv:hover .br50::before{border-color: #94070a;}
  .sinfodiv .sdiv:nth-child(2n + 1){margin-left: 25px;margin-right: 25px;}
  .sinfodiv .nm{line-height: 60px;}
  .sinfodiv .br50{top: 20px;left: 20px;width: 20px;height: 20px;background: #999;}
  .sinfodiv .br50::before{content: '';position: absolute;left: 5px;top: 6px;width: 8px;height: 8px;border-left: 2px solid #fff;border-bottom: 2px solid #fff;transform: rotate(-135deg);}
  .sindex-wrap .notices .sdiv,.snotice-wrap .notives .sdiv{height: 35px;line-height: 35px;}
  .sindex-wrap .newsdiv .notices:nth-child(2){margin: 0 30px;}
  .snotice-wrap .ncont{padding: 40px 35px;line-height: 2.2;}
  .img-media{background: url(../../assets/images/scn1.png) no-repeat -60px -28px;}
  .img-sinfo{background: url(../../assets/images/scn1.png) no-repeat -60px -195px;}
  .img-schange{background: url(../../assets/images/scn1.png) no-repeat -60px -280px;}
  .img-splan{background: url(../../assets/images/scn1.png) no-repeat -60px -364px;}
  .img-splan{background: url(../../assets/images/scn1.png) no-repeat -60px -364px;}
  .img-sproblem{background: url(../../assets/images/scn1.png) no-repeat -60px -448px;}
  .img-sdown{background: url(../../assets/images/scn1.png) no-repeat -60px -528px;}

  /* sindex **/
  .sindex-bg{background: url(../../assets/images/sindex_01.jpg) no-repeat center top}
  .mediadiv {margin-right: 30px;width: 790px;}
  .mediadiv .mcter{width: 385px;height: 235px;}
  .mediadiv .mot{width: 380px;}
  .mediadiv .mot a{height: 28px;}

  .sinfodiv .sdiv{padding-left: 48px;width: 150px;height: 60px;}
  .sinfodiv .sdiv:hover{background-color: #94070a;color: #fff;box-shadow: 0 0 5px #94070a;}
  .sinfodiv .sdiv:hover .br50{background: #fff;}
  .sinfodiv .sdiv:hover .br50::before{border-color: #94070a;}
  .sinfodiv .sdiv:nth-child(2n + 1){margin-left: 25px;margin-right: 25px;}
  .sinfodiv .nm{line-height: 60px;}
  .sinfodiv .br50{top: 20px;left: 20px;width: 20px;height: 20px;background: #999;}
  .sinfodiv .br50::before{content: '';position: absolute;left: 5px;top: 6px;width: 8px;height: 8px;border-left: 2px solid #fff;border-bottom: 2px solid #fff;transform: rotate(-135deg);}
  .sindex-wrap .notices .sdiv,.snotice-wrap .notives .sdiv{height: 35px;line-height: 35px;}
  .sindex-wrap .newsdiv .notices:nth-child(2){margin: 0 30px;}
  .snotice-wrap .ncont{padding: 40px 35px;line-height: 2.2;}
</style>



// WEBPACK FOOTER //
// src/pages/enroll/index.vue